module.exports = __webpack_public_path__ + "img/gift_500.ce4b0416.webp";